// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xbfe","textarea":"styles_textarea__3FJR7"};